<style lang="scss" src="./Bento.scss"></style>

<script>
	import Simple from '@/components/Simple/Simple';

	/**
	 * Bento menu for changing login type.
	 * @vue-data {string} id An unique identifier for the component instance
	 * @vue-data {Object} elements An object containing the structure of the elements to be inserted into bento menu
	 * @vue-data {Object[]} footer An array of footer element objects
	 * @vue-data {string} brandName The name of the current brand
	 * @vue-data {number} chosen The currently chosen login type. NOT USED!
	 * @listens Document#click
	 */
	// TODO Refactor: remove chosen data field because it's not used
	export default {
		name: 'HpBento',
		data () {
			return {
				id: this._uid,
				elements: this.$initialData.bento,
				footer: this.$initialData.bentoFooter,
				brandName: '',
				chosen: -1
			};
		},
		components: {
			'hp-simple': Simple
		},
		methods: {
			/**
			 * Toggles the login type.
			 * @param {onclick} event - The click event fired on bento menu element click
			 * @param {number} row - The row of the chosen bento menu element
			 * @param {number} col - The column of the chosen bento menu element
			 * @param {boolean} fromLoginButton - If the change was triggered from the Login Button. NOT RELEVANT ANYMORE. NO HEADER LOGIN.
			 */
			// TODO Refactor: Remove fromLoginButton because it was only used by header login
			toggleLogin (event, row, col, fromLoginButton) {
				let newURL = this.getTargetURL(event.target);
				if (newURL) {
					if (!fromLoginButton) {
						event.preventDefault();
					}
					let loginElement = this.getLogin();

					for (let i = 0; i < loginElement.childNodes.length; i++) {
						if (loginElement.childNodes[i].hasAttribute && loginElement.childNodes[i].hasAttribute('data-form-login')) {
							loginElement.childNodes[i].action = newURL;

							// open the Login if in header and close the bento menu
							let bento = this.getParentElement(event.target, '[data-component="bento"]');
							if (!bento) {
								return;
							}

							bento.getElementsByTagName('input')[0].checked = false;

							let loginPosition = document.querySelector('html').hasAttribute('data-header-login') ? 'header' : 'content';
							if (loginPosition === 'header') {
								this.getLogin().parentElement.getElementsByTagName('input')[0].checked = true;
							}

							// change text in login
							let eventTargetParent = this.getParentElement(event.target, '[data-component="simple"]');
							let newText = eventTargetParent.getElementsByTagName('figcaption')[0].innerHTML;
							document.querySelector('[data-login-text]').innerHTML = newText;

							// change icon in login
							let newIcon = eventTargetParent.querySelector('[data-component="icon"]').cloneNode(true);
							document.querySelector('[data-login-icon]').innerHTML = '';
							document.querySelector('[data-login-icon]').appendChild(newIcon);

							this.createHiddenValuesAndChangeLink(row, col);
							break;
						}
					}
				} // else it's just a normal link going somewhere... bye bye
			},
			/**
			 * ???
			 * @param {HTMLElement} element The element to get the parent element of
			 * @returns {string|HTMLElement} Either the value of href if it's an clickout or the parent element if it's a login change
			 * @see {@link Helper.getParentElement}
			 */
			// TODO Refactor: What does this function actually do? Is the name actually meaningful?
			getTargetURL (element) {
				let parent = this.getParentElement(element, '[data-login]');
				return parent !== undefined ? parent.getAttribute('href') : parent;
			},
			/**
			 * Creates the hidden inputs for login based on bento menu element identified by row and column.
			 * @param {number} row The row of the bento menu element
			 * @param {number} col The column of the bento menu element
			 */
			createHiddenValuesAndChangeLink (row, col) {
				const currentBentoPoint = this.elements[row][col];

				// Hidden Values
				const container = document.querySelector('[data-hidden-values]');
				const params = currentBentoPoint.formHiddenParams;
				let letMeIn = '';
				for (let key in params) {
					if (params.hasOwnProperty(key)) {
						letMeIn += '<input type="hidden" name="' + key + '" value="' + params[key] + '">';
					}
				}

				container.innerHTML = letMeIn;

				// Link
				const form = document.querySelector('[data-form-login]');
				form.setAttribute('action', currentBentoPoint.link.href);
			},
			/**
			 * Returns parent element of given element by attribute name.
			 * @param {HTMLElement} element - The element to find parent for
			 * @param {string} parentAttribute - The attribute of the parent element to look for
			 * @returns {undefined|HTMLElement} The Parent Element
			 */
			// TODO Refactor: Same as Helper.getParentElement
			getParentElement (element, parentAttribute) {
				if (element === document.body) {
					return undefined;
				}
				if (element.matches(parentAttribute)) {
					return element;
				} else {
					return this.getParentElement(element.parentElement, parentAttribute);
				}
			},
			// TODO Refactor: Not used anymore. Only content login available.
			getLogin () {
				let loginPosition = document.querySelector('html').hasAttribute('data-header-login') ? 'header' : 'content';

				switch (loginPosition) {
					case 'header':
						return document.querySelector('header > [data-component="login"]');
					case 'content':
						return document.querySelector('.main-content  > [data-content] > [data-content-login] > [data-component="login"]');
					default:
						return undefined;
				}
			},
			/**
			 * Sets all checked inputs to unchecked state.
			 * @param {onclick} ev - The click event fired by caller
			 */
			// TODO Refactor: checkFocus => uncheckAllCheckboxes
			checkFocus: function (ev) {
				let checkbox = this.$el.querySelector('input:checked');
				if (checkbox && !this.$el.contains(ev.target)) {
					checkbox.checked = false;
				}
			}
		},
		mounted () {
			this.brandName = process.env.VUE_APP_BRAND_NAME;
			this.$nextTick(() => {
				document.addEventListener('click', this.checkFocus);
			});
		}
	};
</script>

<template>
	<div data-component="bento">
		<input :id="'bento' + id" data-hidden type="checkbox" />
		<label :for="'bento' + id">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</label>
		<div data-layer>
			<label :for="'bento' + id" data-close-button data-grid-end-self>
				<span></span>
				<span></span>
			</label>
			<div :key="index" data-grid-row data-part="bento-row" v-for="(row, index) in elements">
				<div :key="index2" @click="toggleLogin($event, index, index2)" data-part="bento-tile" v-for="(element, index2) in row">
					<hp-simple v-bind="element"></hp-simple>
				</div>
			</div>
			<div data-grid-row data-part="bento-row">
				<a :href="el.href" :key="index" v-for="(el, index) in footer">{{ el.text }}</a>
			</div>
		</div>
	</div>
</template>
